<template>
  <h2 class="gradation">ご確認ください</h2>

  <div v-if="isLoading">
    <div class="loading-tile-secondary">
      <div class="loading-tile-secondary__thumbnail">
      </div>
      <div class="loading-tile-secondary__body loading-tile-secondary-body">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
  <div v-else>
    <template v-for="content in primary_contents" :key="content">
      <article-secondary class="article my-3" :content-title="content.title" :content-lead="content.lead"
        :content-desc="content.description" :content-uri="content.uri" :thumbnail-uri="content.thumbnail_url" :date-time="content.datetime" />
    </template>
  </div>

  <div v-if="isLoading">
    <div>
      <div class="loading-tile-secondary">
        <div class="loading-tile-secondary__thumbnail">
        </div>
        <div class="loading-tile-secondary__body loading-tile-secondary-body">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <div>
      <div class="loading-tile-secondary">
        <div class="loading-tile-secondary__thumbnail">
        </div>
        <div class="loading-tile-secondary__body loading-tile-secondary-body">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <template v-for="content in secondary_contents" :key="content">
      <article-secondary class="article my-3" :content-title="content.title" :content-lead="content.lead"
        :content-desc="content.description" :content-uri="content.uri" :thumbnail-uri="content.thumbnail_url" :date-time="content.datetime" />
    </template>
  </div>

  <div class="article my-3" v-if="false">
    <v-btn color="primary" variant="flat" @click="fetchContent" block>Fetch</v-btn>
    <div>{{ condition }}</div>
  </div>
</template>

<style scoped>
.loading-tile,
.loading-tile-secondary {
  display: flex;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  opacity: 0.6;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
}

.loading-tile::after,
.loading-tile-secondary::after {
  content: "";
  position: absolute;
  width: 300%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.6;
  background: linear-gradient(110deg, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 0) 40%, rgba(250, 250, 250, 0.5) 50%, rgba(250, 250, 250, 0) 60%, rgba(250, 250, 250, 0) 100%);
  animation: gradient-animation_2 1.2s linear infinite;
}

.loading-tile__thumbnail {
  width: 40%;
  aspect-ratio: 1;
  background-color: #eee;
  /*  border-radius: 5px;*/
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url('../assets/images/empty.gif');
}

.loading-tile__body {
  width: calc(100% - 40%);
}

.loading-tile-body {
  display: flex;
  flex-flow: column;
  text-align: left;
}

.loading-tile-body>div,
.loading-tile-secondary__body>div {
  background-color: #cacaca;
  height: 20px;
  margin-bottom: 5px;
}

.loading-tile-secondary__thumbnail {
  width: 25%;
  aspect-ratio: 1;
  background-color: #eee;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url('../assets/images/empty.gif');
}

.loading-tile-secondary__body {
  width: calc(100% - 25%);
}

.loading-tile-secondary-body {
  display: flex;
  flex-flow: column;
  text-align: left;
  ;
}

@keyframes gradient-animation_2 {
  0% {
    transform: translateX(-100%);
  }
}
</style>

<script>
import ArticleSecondary from "./ArticleSecondary.vue"
import axios from "axios"

export default {
  name: 'ActionItem',
  components: {
    ArticleSecondary
  },
  data() {
    return {
      primary_contents: [],
      secondary_contents: [],
      isLoading: true,
    }
  },
  // コンポーネントマウントリスナ
  async mounted() {
    this.fetchContent();
  },
  methods: {
    async fetchContent() {

      const res = await axios.get('/api/private').catch(() => {
        return;
      });

      this.primary_contents.push(res.data.shift())

      for (const content of res.data) {
        this.secondary_contents.push(content)
      }

      // コンテンツロードを伝播する
      this.$nextTick(() => {
        this.isLoading = false;
      })

    }
  }
}
</script>